import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';

export interface InitiateAccountTransferParams {
  clientId: string;
  managedAccountId: string;
  fromAccountId: string;
  accountNumber: string;
}

const initiateAccountTransfer = async (params: InitiateAccountTransferParams) =>
  authFetch('/Consumer/AcatsTransfers/InitiateTransfer', {
    method: 'POST',
    ...httpBodyOptions(params, true),
  });

export const useInitiateAccountTransferMutation = () => {
  return useMutation(initiateAccountTransfer);
};
